import React, { Component } from "react";
import Market from "./Market";
import MarketNavbar from "./MarketNav/MarketNavbar";

class MarketErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <MarketNavbar />
          <div style={{ padding: "120px 24px", textAlign: "center", fontFamily: "Montserrat, sans-serif" }}>
            <h1 style={{ marginBottom: 12 }}>Marketplace</h1>
            <p style={{ color: "#666" }}>We could not load the home page. Please refresh and try again.</p>
          </div>
        </>
      );
    }
    return this.props.children;
  }
}

const MarketPage = () => (
  <MarketErrorBoundary>
    <Market />
  </MarketErrorBoundary>
);

export default MarketPage;
